import theme from '../../config/theme';

interface ILoadingProps {
  size?: number;
  color?: string;
}

/** react-loading's default size. */
const DEFAULT_SIZE = 64;

/**
 * The spinner of react-loading 2 (type "spin"), with its markup: a div with the colour as fill and the size, around
 * its SVG. react-loading bundles its own React 16 element code, which React 19 does not render.
 */
const Loading = ({ size = DEFAULT_SIZE, color }: ILoadingProps) => {
  const defaultColor = theme.primaryColor;
  return (
    <div style={{ fill: color || defaultColor, height: size, width: size }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          opacity=".25"
          d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
        />
        <path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 16 16"
            to="360 16 16"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  );
};

export default Loading;
